let myMixin = {
  computed: {
    hasName () {
      return this.$store.getters.raterName !== ''
    }
  },
  methods: {
    getCookie: function (cookiename) {
      // Get name followed by anything except a semicolon
      let cookiestring = RegExp('' + cookiename + '[^;]+').exec(document.cookie)
      // Return everything after the equal sign
      if (cookiestring) {
        cookiestring = unescape(cookiestring.toString().replace(/^[^=]+./, ''))
      } else {
        cookiestring = false
      }

      return cookiestring
    },
    setCookie: function (name, value, days) {
      let date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      let expires = '; expires=' + date.toUTCString()
      document.cookie = name + '=' + value + expires + '; path=/'
    },
    /**
     * Given it's monday and you want to get days until next monday you would
     * call the function this.daysUntilNextDay('monday'). Expect result 0 since
     * today is monday.
     * @default 'friday'
     * @param {string} dayOfWeek Long name of day i.e sunday, friday
     * @return {object} Contains how many days left and boolean for if is today
     */
    daysUntilNextDay (dayOfWeek = 'friday') {
      let weekDays = {
        'sunday': 0,
        'monday': 1,
        'tuesday': 2,
        'wednesday': 3,
        'thursday': 4,
        'friday': 5,
        'saturday': 6
      }
      // Convert to number
      dayOfWeek = weekDays[dayOfWeek]
      let today = new Date()
      let isToday = false
      if (today.getDay() === dayOfWeek) isToday = true

      let nextFriday = new Date()
      nextFriday.setDate(today.getDate() + (7 + dayOfWeek - today.getDay() - 1) % 7 + 1)
      // 24 * 60 * 60 * 1000 = 86400000 milliseconds a day
      const daysLeft = Math.floor((Date.parse(nextFriday) - Date.parse(today)) / 86400000)

      return { 'isToday': isToday, 'count': daysLeft }
    },
    /**
     *
     * @param {integer} count The number to display
     * @param {string} noun what to pluralize
     * @param {string} suffix
     */
    maybePluralize (count, noun, suffix) {
      return `${count} ${noun}${count !== 1 ? suffix : ''}`
    }
  }
}

export default myMixin
